import React, { useContext } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import {
  IconButton,
  Text,
  Link,
  Stack,
  TeachingBubble,
  TooltipHost,
} from "office-ui-fabric-react";
import { getTheme, Icon, MessageBarType } from "@fluentui/react";
import { putMenu } from "./Functions/Put";
import { MenuContext } from "./Contexts/MenuContext";
import EditableMenuNew from "./EditableMenuNew";
import EditableMenuMessage from "./EditableMenuMessage";
import { v4 as uuid4 } from "uuid";
import * as utilMenu from "./Functions/util-menu";

export const EditableMenuTitle = ({ addMenuItem }) => {
  const [teachingBubbleVisible, { toggle: toggleTeachingBubbleVisible }] =
    useBoolean(false);

  const [menuContext, setMenuContext] = useContext(MenuContext);

  return (
    <Stack verticalAlign="center" style={{ marginLeft: 24, marginRight: 24 }}>
      <EditableMenuMessage></EditableMenuMessage>
      <Stack horizontal verticalAlign="center" style={{ marginLeft: 24 }}>
        <Text
          variant="xxLarge"
          style={{
            color: getTheme().palette.neutralPrimary,
          }}
        >
          Menu Edit
        </Text>

        <TooltipHost content="Tooltip" id="TooltipButton">
          <IconButton
            id="MenuEditHelpButton"
            iconProps={{ iconName: "Info" }}
            ariaLabel="Info"
            onClick={toggleTeachingBubbleVisible}
          />
        </TooltipHost>
        {teachingBubbleVisible && (
          <TeachingBubble
            target="#MenuEditHelpButton"
            hasSmallHeadline={true}
            // headline="Help"
            closeButtonAriaLabel="Close"
            isWide={true}
            primaryButtonProps={{
              children: "Got it!",
              onClick: toggleTeachingBubbleVisible,
            }}
          >
            <Text>
              <strong>Target</strong>
            </Text>
            <br />
            <Text>Frame - loads in frame (recommended for most cases)</Text>
            <br />
            <Text>Blank - opens link in a new tab</Text> <br />
            <Text>Self - navigates away from the portal</Text>
            <br />
            <Text>
              <strong>Icon</strong>
            </Text>
            <br />
            <Text>
              Obtain your icon name from
              <Link
                style={{
                  color: "inherit",
                }}
                href="https://uifabricicons.azurewebsites.net/"
                target="_blank"
              >
                {" "}
                the icon picker <Icon iconName="OpenInNewWindow" />
              </Link>
            </Text>
            <br />
            <Text>
              Do not use icons on menu items with children as the image overlaps
              the chevron
            </Text>{" "}
            <br />
          </TeachingBubble>
        )}
        <TooltipHost content="Back To Portal" id="BackToPortalButton">
          <IconButton
            iconProps={{ iconName: "Back" }}
            ariaLabel="Back To Portal"
            onClick={() =>
              setMenuContext((prevState) => ({
                ...prevState,
                isEditing: false,
              }))
            }
          />
        </TooltipHost>
        <TooltipHost content="Save Changes" id="SaveChangesButton">
          <IconButton
            iconProps={{ iconName: "Save" }}
            ariaLabel="Save Changes"
            onClick={() =>
              putMenu(
                utilMenu.toRecursiveMenu(menuContext.menuEdit),
                setMenuContext
              )
            }
          />
        </TooltipHost>
        <EditableMenuNew addMenuItem={addMenuItem} />
        <TooltipHost content="Discard Changes" id="DiscardChangesButton">
          <IconButton
            iconProps={{ iconName: "Undo" }}
            style={{
              color: "red",
            }}
            ariaLabel="Discard Changes"
            onClick={() => {
              if (
                window.confirm(
                  "Are you sure you want to discard all your changes?"
                )
              ) {
                setMenuContext((prevState) => ({
                  ...prevState,
                  menuEdit: utilMenu.toIterativeMenu(prevState.menu),
                  menuEditStateDisplay: true,
                  menuEditStateSeverity: MessageBarType.info,
                  menuEditStateMessage: "Changes Discarded",
                  menuEditStateId: uuid4().toString(),
                }));
              }
            }}
          />
        </TooltipHost>
      </Stack>
    </Stack>
  );
};

export default EditableMenuTitle;
